import { GDFMetarTafFlightCategory, GDFMetarRecord } from '../../../gdf/type';
import { flightCategoryToString } from '../../../utils/enum-display';

const windDirs = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
const skyCoverage = ['Clear', 'Sky clear', 'Few', 'Scattered', 'Broken', 'Overcast', 'OVX'];

export default function MetarTooltip({ record }: { record: GDFMetarRecord }) {
    let windDir = '';
    if (record.windDir === null) {
        windDir = '-';
    } else if (record.windDir === 0xfffe) {
        windDir = 'Variable';
    } else {
        let tmp = Math.floor(record.windDir / 22);
        if (record.windDir > 349 || record.windDir < 12) {
            tmp = 0;
        }
        windDir = windDirs[tmp] + ` (${record.windDir}°)`;
    }

    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', columnGap: '0.5rem' }}>
                <div>Station:</div>
                <div>{record.id}</div>

                <div>Flight category:</div>
                <div>{flightCategoryToString[record.flightCategory] ?? flightCategoryToString[GDFMetarTafFlightCategory.unknown]}</div>

                <div>Winds:</div>
                <div>
                    {windDir}
                    <span> at </span>
                    {record.windSpeed === null && <span>-</span>}
                    {record.windSpeed !== null && <span>{record.windSpeed} kts</span>}
                    <span> gusts to </span>
                    {record.windGusts === null && <span>-</span>}
                    {record.windGusts !== null && <span>{record.windGusts} kts</span>}
                </div>

                <div>Ceiling:</div>
                <div>
                    {record.ceiling === null && <span>-</span>}
                    {record.ceiling === 0x63ff38 && <span>&gt; 12,000 ft ({feetToMeters(12_000)})</span>}
                    {record.ceiling !== null && record.ceiling !== 0x63ff38 && (
                        <span>
                            {record.ceiling.toLocaleString('en-US')} ft ({feetToMeters(record.ceiling)})
                        </span>
                    )}
                </div>

                <div>Visibility:</div>
                <div>
                    {record.visibility === null && <span>-</span>}
                    {record.visibility !== null && (
                        <>
                            {record.visLessGrt === 'L' && '<'}
                            {record.visLessGrt === 'G' && '>'}
                            {record.visibility.toFixed(2)} SM
                        </>
                    )}
                </div>

                <div>Temp:</div>
                <div>
                    {record.temperature === null && '-'}
                    {record.temperature !== null && <span>{record.temperature} °C</span>}
                </div>

                <div>Dew Pt:</div>
                <div>
                    {record.dewPoint === null && '-'}
                    {record.dewPoint !== null && <span>{record.dewPoint} °C</span>}
                </div>

                <div>Alt:</div>
                <div>
                    {record.altimeter === null && '-'}
                    {record.altimeter !== null && <span>{record.altimeter.toFixed(2)}</span>}
                </div>

                <div>Sky:</div>
                <div>
                    {record.skyCoverage === null && '-'}
                    {record.skyCoverage !== null && (skyCoverage[record.skyCoverage - 1] ?? 'Unknown')}
                </div>
            </div>
            <div className="pt-3" style={{ maxWidth: 300, lineBreak: 'anywhere' }}>
                {record.text}
            </div>
        </div>
    );
}

export function feetToMeters(input: number) {
    return Math.round(input * 0.3048).toLocaleString('en-US') + ' m';
}
